import { Drawer } from 'antd'
import { useContext } from 'react'
import { WorkareaItemTypes } from '../../../common/constants'
import { useWorkareaGroupsQuery } from '../../../domain/workareas/groupsQueries'
import { ItemsContext } from '../ItemsRoot'
import { ServerState, ViewItemFilter, createViewItems } from '../itemModel'
import ItemCalculationsContent from './ItemCalculationsContent'

type Props = {
  open: boolean
  onClose: () => void
}

const ItemCalculationsDrawer = ({ open, onClose }: Props) => {
  const { jobItemsQuery, changeSet, jobData } = useContext(ItemsContext)
  const workareaGroupsQuery = useWorkareaGroupsQuery(jobData.jobId)

  const groupSortIndexById = Object.fromEntries(
    (workareaGroupsQuery.data ?? []).map(group => [group.id, group.sortIndex])
  )

  const catalogItems = jobItemsQuery.data?.catalogItems ?? []

  const estimatedServerState: ServerState = {
    workareaItems: jobItemsQuery.data?.estimatedItems ?? [],
    catalogItems,
    templateItems: [],
  }
  const actualServerState: ServerState = {
    workareaItems: jobItemsQuery.data?.actualItems ?? [],
    catalogItems,
    templateItems: [],
  }

  const workareaIds = jobData.workareas.map(x => x.id)

  const filter: ViewItemFilter = { workareaIds }
  const estimatedItems = createViewItems(changeSet, estimatedServerState, jobData.visitData, jobData.budgets,
    jobData.jobIsSold, jobData.workareas, { ...filter, workareaItemType: WorkareaItemTypes.Estimated })
    .filter(x => !x.isEmptyRow && workareaIds.includes(x.workareaId))
  const actualItems = createViewItems(changeSet, actualServerState, jobData.visitData, jobData.budgets,
    jobData.jobIsSold, jobData.workareas, { ...filter, workareaItemType: WorkareaItemTypes.Actual })
    .filter(x => !x.isEmptyRow && workareaIds.includes(x.workareaId))

  return <Drawer
    title="Item Calculation Details"
    open={open}
    onClose={onClose}
    placement="right"
    width="90%"
  >
    <ItemCalculationsContent
      estimatedItems={estimatedItems}
      actualItems={actualItems}
      workareas={jobData.workareas}
      groupSortIndexById={groupSortIndexById}
    />
  </Drawer>
}

export default ItemCalculationsDrawer
